import React, { ReactNode, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';

interface IMetaTags {
    title: string;
    description: string;
    children: ReactNode;
    thumbnailUrl?: string;
}

const MetaTags: React.FC<IMetaTags> = ({ title, description, thumbnailUrl, children }) => {
    const [thumbnailDimension, setThumbnailDimension] = useState({ width: '600', height: '400' });
    useEffect(() => {
        const fetchImageDimensions = async () => {
            try {
                const img = new Image();
                img.src = thumbnailUrl as string;
                img.onload = () => {
                    const newWidth = Math.floor(img.width * 0.5); // Reduce width by 50%
                    const newHeight = Math.floor(img.height * 0.5); // Reduce height by 50%
                    setThumbnailDimension({ width: String(newWidth), height: String(newHeight) });
                };
            } catch (error) {
                console.error('Error fetching image dimensions:', error);
            }
        };

        fetchImageDimensions();
    }, [thumbnailUrl]);
    return (
        <div style={{ width: '100%' }}>
            {/* Set dynamic Open Graph meta tags */}
            <Helmet>
                <title>{title}</title>
                <meta property="og:title" content={title} />
                <meta property="og:description" content={description} />
                <meta property="og:image" content={thumbnailUrl} />
                <meta property="og:image:url" content={thumbnailUrl} />
                <meta property="og:image:secure_url" content={thumbnailUrl} />
                <meta property="og:image:width" content={thumbnailDimension.width} />
                <meta property="og:image:height" content={thumbnailDimension.height} />
            </Helmet>
            {/* Render children */}
            {children}
        </div>
    );
};

MetaTags.defaultProps = {
    description: 'Create | Share | Unleash',
    title: 'Thspian',
};

export { MetaTags };
